<template>
    <v-server-table
        ref="table"
        :url="url"
        :columns="fields"
        :options="options">
        <!-- Pass on all named slots -->
        <slot
            v-for="slot in Object.keys($slots)"
            :name="slot"
            :slot="slot" />

        <!-- Pass on all scoped slots -->
        <template
            v-for="slot in Object.keys($scopedSlots)"
            :slot="slot"
            slot-scope="scope">
            <slot
                v-bind="scope"
                :name="slot" />
        </template>
    </v-server-table>
</template>

<script>
    export default {
        name: 'design-2021-apprentice-server-data-table',
        props: {
            fields: {},
            options: {},
            url: {
                type: String,
                default: '',
            },
        },
        data() {
            return {};
        },
    };
</script>

<style scoped lang="scss">
    .apprentice-table-header {
        &,
        .apprentice-table-filters,
        .apprentice-data-table-actions {
            display: flex;
        }

        flex-direction: row;
        flex: 1 0 100%;
        flex-wrap: wrap;
        justify-content: space-between;
        margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');

        .apprentice-data-table-actions,
        .apprentice-table-filters {
            flex: 1 0 100%;
        }

        .apprentice-data-table-actions {
            flex-direction: column;

            > div:not(:last-child),
            > button:not(:last-child),
            > span:not(:last-child),
            > select:not(:last-child) {
                margin-bottom: map-get($grid-gutter-spacing, 'ten');
            }
        }

        .column-filters ::v-deep {
            margin-right: map-get($grid-gutter-spacing, 'ten');

            .hide-columns-menu {
                padding: 0;

                .dropdown-header {
                    padding: map-get($grid-gutter-spacing, 'ten') map-get($grid-gutter-spacing, 'twenty-one');
                    font-size: $base-font-size;
                    font-weight: $font-weight-medium;
                    color: var(--primary);
                    height: auto;
                }

                .dropdown-divider {
                    margin: 0;
                }
            }
        }
    }

    .apprentice-table-wrapper {
        .table-responsive {
            margin-bottom: 0;
        }
    }

    ::v-deep .VueTables__limit-field {
        label {
            display: none;
        }
    }

    ::v-deep .VueTables__search-field {
        label {
            display: none;
        }

        input {
            color: $primary;
            align-items: center;
            background-color: $secondary-background-color;
            padding: map-get($grid-gutter-spacing, 'fifteen') map-get($grid-gutter-spacing, 'ten');
            border-top-right-radius: $border-radius-content;
            border-bottom-right-radius: $border-radius-content;
        }
    }

    ::v-deep table {
        td {
            font-size: $default-font-size;
        }

        th,
        tbody tr td {
            border: none;
            vertical-align: middle;
        }

        tbody {
            tr {
                &:hover,
                &:nth-of-type(odd) {
                    background-color: $secondary-background-color;
                }
            }

            tr.b-table-empty-row {
                background-color: transparent;

                .not-found {
                    margin-top: map-get($grid-gutter-spacing, 'twenty-one') * 2;
                }
            }

            .btn {
                font-size: 1.3125rem;

                > span,
                > div {
                    font-size: initial;
                }
            }
        }

        .total-records {
            text-align: right;
        }

        .tfoot-bottom {
            display: flex;
            justify-content: space-evenly;
            align-items: center;
            align-content: flex-end;

            .apprentice-pagination {
                margin-top: 0;
            }

            .apprentice-pagination,
            .muted-text {
                margin-left: auto;
            }

            .pagination {
                margin: 0;
            }
        }
    }

    @media (min-width: map-get($grid-breakpoints, 'sm')) {
        .apprentice-table-header {
            flex-direction: column;

            .page-records {
                margin-right: map-get($grid-gutter-spacing, 'twenty-one');
            }

            .search {
                flex-grow: 1;
                max-width: 380px;

                .input-group {
                    flex-wrap: nowrap;

                    input {
                        width: auto;
                    }
                }
            }

            .apprentice-data-table-actions {
                flex-direction: row;
                align-items: center;

                > div:not(:last-child),
                > button:not(:last-child),
                > span:not(:last-child),
                > select:not(:last-child) {
                    margin-bottom: 0;
                }
            }
        }

        ::v-deep .apprentice-data-table {
            white-space: nowrap;
            overflow-x: auto;
        }
    }

    @media (min-width: map-get($grid-breakpoints, 'md')) {
        .apprentice-table-header {
            flex-wrap: nowrap;

            .apprentice-table-filters {
                align-items: center;
                align-content: center;
                flex: 1 0 100%;
            }

            .page-records,
            .column-filters {
                margin-right: map-get($grid-gutter-spacing, 'twenty-one');
            }

            .search,
            .apprentice-data-table-actions {
                flex-grow: 1;
            }

            .apprentice-data-table-actions {
                justify-content: flex-start;
                align-items: center;
            }
        }

        ::v-deep .apprentice-data-table {
            white-space: normal;
            overflow-x: auto;
        }
    }

    @media (min-width: map-get($grid-breakpoints, 'xl')) {
        .apprentice-table-header {
            flex-direction: row;

            .apprentice-table-filters {
                flex: initial;
                margin-bottom: 0;
            }

            .apprentice-data-table-actions {
                flex: initial;
                flex-direction: row;
                justify-content: flex-end;
            }
        }
    }
</style>
